import clsx from 'clsx';

export function Box({ children, className = '', padding = 'p-6' }) {
  return (
    <div className={clsx(' bg-white rounded-md shadow-md', padding, className)}>
      {children}
    </div>
  );
}
